var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { apiGetOneProRfpShareDocumentMessage } from '@/actions/ProRfpShareDocumentActions';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * データ取得
 */
export const useRfpProfessionalFileFetchMessage = () => {
    // ファイル共有データ
    const [fileShareData, changeFileShareData] = useState();
    /**
     * ファイル共有データを取得する
     */
    const fetchFileShare = useCallback((argsDispatch, { id: argsId }, argsUnmountRef) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { payload } = yield wrapDispatch(argsDispatch, apiGetOneProRfpShareDocumentMessage({ path: { id: argsId } }, {}));
            if (!argsUnmountRef.current) {
                changeFileShareData(payload || null);
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), []);
    return {
        changeFileShareData,
        fetchFileShare,
        fileShareData,
    };
};
